<select-gp-for-cw
    type="stepByStep"
    [subtitle]="
        'Your selection will help AIVA generate a full composition out of the musical elements you\'ll provide next.'
    "
    [selectGPForCW]="selectGPForCW.bind(this)"></select-gp-for-cw>
